import { FC, useState } from "react";
import PositiveFeedbackFormSection from "./PositiveFeedbackFormSection";
import { Feedback } from "../../store/feedback";
import NegativeFeedbackFormSection from "./NegativeFeedbackFormSection";
import FeedbackPolaritySelector, { FeedbackPolarity } from "./FeedbackPolaritySelector";
import { getTpoUserId, getUserId } from "../../adalConfig";
import { X, } from "react-feather";

interface FeedbackFormProps {
    onFeedbackPolarityButtonClick: (feedbackPolarity: FeedbackPolarity) => void;
    onFeedbackSubmit: (feedback: Omit<Feedback, 'id' | 'answer' | 'question' | 'navigationLink'>) => void;
    isLoading: boolean;
    closeMenu: (close: boolean) => void;
    extendHeight: (extend : boolean) => void;
}

const FeedbackForm: FC<FeedbackFormProps> = (props) => {
    const [selectedFeedbackPolarity, setSelectedFeedbackPolarity] = useState<FeedbackPolarity | undefined>(undefined);
    
    const handlePositiveFeedbackButtonClick = () => {
        setSelectedFeedbackPolarity(FeedbackPolarity.Positive);
        props.onFeedbackPolarityButtonClick(FeedbackPolarity.Positive);
    }
    
    const handleNegativeFeedbackButtonClick = () => {
        setSelectedFeedbackPolarity(FeedbackPolarity.Negative);
        props.onFeedbackPolarityButtonClick(FeedbackPolarity.Negative);
    }
    
    const handleFeedbackSubmit = (feedback: Pick<Feedback, | 'feedbackTypeId' | 'userComments' | 'userCopySection'>) => {
        if (selectedFeedbackPolarity === undefined) {

            return;
        }

        props.onFeedbackSubmit({ ...feedback, helpfulFlag: selectedFeedbackPolarity === FeedbackPolarity.Positive, userId: getUserId(), tpoUserId: getTpoUserId()});
        props.closeMenu(true);
    }

    const toggleFeedbackElementHeight = (extend : boolean) => {
        props.extendHeight(extend);
    }

    const handleCloseButton = () => {
        setSelectedFeedbackPolarity(undefined);
        props.closeMenu(true);
        props.extendHeight(false);
    }
    
    return (
        <div id="feedback-div">
            <FeedbackPolaritySelector onPositiveFeedbackButtonClick={handlePositiveFeedbackButtonClick} onNegativeFeedbackButtonClick={handleNegativeFeedbackButtonClick} value={selectedFeedbackPolarity} extendHeight={toggleFeedbackElementHeight} />
            <form className="form" id="feedbackForm" name="form1">
                {selectedFeedbackPolarity === FeedbackPolarity.Positive && <PositiveFeedbackFormSection onSubmit={handleFeedbackSubmit} />}
                {selectedFeedbackPolarity === FeedbackPolarity.Negative && <NegativeFeedbackFormSection onSubmit={handleFeedbackSubmit} extendHeight={toggleFeedbackElementHeight} />}
            </form>
            <button className={'closeButton ' + (selectedFeedbackPolarity === undefined ? "hidden" : "")} onClick={handleCloseButton}><X /></button>
        </div>
    );
}

export default FeedbackForm;